import React, {FC} from 'react'
import {RouteComponentProps} from 'react-router-dom'
import CloseDown from '@/components/Modal/closeDown'
import '@/styles/page/Stop.less'

type StopProps = RouteComponentProps

const Stop:FC<StopProps> = props => {
  const mes:string = localStorage.getItem('stopMes')|| ''

  return(
    <>
      <CloseDown msg={mes} className='gc_stop'></CloseDown>
    </>
  )
}

export default Stop
